import React from 'react';

import { Circle } from '@mui/icons-material';
import { SxProps, Tooltip } from '@mui/material';

type Props = {
  alive?: boolean;
  sx?: SxProps;
};

export const StatusDot = ({ alive, sx }: Props) => {
  return (
    <Tooltip title={null}>
      <Circle
        sx={{
          color:
            typeof alive === 'boolean'
              ? alive
                ? 'success.main'
                : 'error.main'
              : 'grey.700',
          ...(sx ?? {}),

          '@keyframes pulse': {
            '0%': {
              opacity: 1,
            },
            '50%': {
              opacity: 0.5,
            },
            '100%': {
              opacity: 1,
            },
          },
          animation:
            typeof alive !== 'boolean' ? 'pulse 1.5s infinite' : undefined,
        }}
      />
    </Tooltip>
  );
};
